import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

export function useFetch(url, deps = [], enabled = true) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const reload = useCallback(() => {
    if (!enabled || !url) { setLoading(false); return; }
    setLoading(true);
    api.get(url).then((r) => { setData(r.data); setError(null); }).catch((e) => setError(e)).finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, enabled, ...deps]);
  useEffect(() => { reload(); }, [reload]);
  return { data, loading, error, reload, setData };
}

export const selectCls = "h-9 w-full rounded-md border border-slate-200 bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-[color:var(--brand-blue)]";
